module.exports = __webpack_public_path__ + "static/media/Refmonkey.1c42ff15.png";